import {
  AUTH_FORM_EMAIL_TAKEN_MESSAGE,
  AUTH_FORM_GENERIC_ERROR_MESSAGE,
} from "@shared/constants";

const EMAIL_TAKEN_PATTERN = /email has already been taken/i;

function getErrorMessage(error: unknown) {
  if (typeof error === "string") return error;

  if (error instanceof Error) return error.message;

  return String(error);
}

export default function resolveAuthFormServerErrorMessage(error: unknown) {
  const message = getErrorMessage(error);

  if (EMAIL_TAKEN_PATTERN.test(message)) {
    return AUTH_FORM_EMAIL_TAKEN_MESSAGE;
  }

  return AUTH_FORM_GENERIC_ERROR_MESSAGE;
}
